import React from 'react'

export const TeamPerformanceIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
   props
) => (
   <svg
      xmlns="http://www.w3.org/2000/svg"
      width={21}
      height={21}
      viewBox="0 0 21 21"
      fill="none"
      {...props}
   >
      <g opacity="0.7" clipPath="url(#clip0_66_101)">
         <path
            d="M7.73047 10.5C10.488 10.5 12.7305 8.2575 12.7305 5.5C12.7305 2.7425 10.488 0.5 7.73047 0.5C4.97297 0.5 2.73047 2.7425 2.73047 5.5C2.73047 8.2575 4.97297 10.5 7.73047 10.5ZM7.73047 2.16667C9.5688 2.16667 11.0638 3.66167 11.0638 5.5C11.0638 7.33833 9.5688 8.83333 7.73047 8.83333C5.89214 8.83333 4.39714 7.33833 4.39714 5.5C4.39714 3.66167 5.89214 2.16667 7.73047 2.16667ZM8.5638 13C8.5638 13.46 8.19047 13.8333 7.73047 13.8333C4.5138 13.8333 1.89714 16.45 1.89714 19.6667C1.89714 20.1267 1.5238 20.5 1.0638 20.5C0.603802 20.5 0.230469 20.1267 0.230469 19.6667C0.230469 15.5317 3.59547 12.1667 7.73047 12.1667C8.19047 12.1667 8.5638 12.54 8.5638 13ZM17.7305 12.2092V12.1667C17.7305 11.2475 16.983 10.5 16.0638 10.5H14.3971C13.478 10.5 12.7305 11.2475 12.7305 12.1667V12.2092C11.3205 12.4133 10.2305 13.6183 10.2305 15.0833V17.5833C10.2305 19.1917 11.5388 20.5 13.1471 20.5H17.3138C18.9221 20.5 20.2305 19.1917 20.2305 17.5833V15.0833C20.2305 13.6183 19.1405 12.4133 17.7305 12.2092ZM13.1471 13.8333H17.3138C18.003 13.8333 18.5638 14.3942 18.5638 15.0833V15.5H11.8971V15.0833C11.8971 14.3942 12.458 13.8333 13.1471 13.8333ZM17.3138 18.8333H13.1471C12.458 18.8333 11.8971 18.2725 11.8971 17.5833V17.1667H14.3971C14.3971 17.6267 14.7705 18 15.2305 18C15.6905 18 16.0638 17.6267 16.0638 17.1667H18.5638V17.5833C18.5638 18.2725 18.003 18.8333 17.3138 18.8333Z"
            fill="white"
         />
      </g>
      <defs>
         <clipPath id="clip0_66_101">
            <rect
               width="20"
               height="20"
               fill="white"
               transform="translate(0.230469 0.5)"
            />
         </clipPath>
      </defs>
   </svg>
)
